import React from "react";
import { Row } from "react-bootstrap";
import { BreadCrumbItem } from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import TableSection from "./TableSection";
import LoadingScreen from "../../organisms/LoadingScreen";
import ServerErrorModal from "../../organisms/ServerErrorModal";
import InformationModal from "../../organisms/InformationModal";
import { useNavigate } from "react-router-dom";
import { RUTA_ASISTENCIA } from "../../../services/rutas";
import { useExisteListaAsistenciaDeHoySpa } from "../../../services/asistenciaSpaServicios";

const breadCrumbs: BreadCrumbItem[] = [
  {
    path: "/",
    label: "Inicio",
  },
  {
    path: "/asistencia",
    label: "Asistencia",
  },
  {
    path: "/checkin",
    label: "Check in",
    isActive: true,
  },
];

function CheckinAsistenciaSpa() {
  const navigate = useNavigate();

  const {
    data: existeListaDeHoy,
    isLoading,
    error,
    isSuccess,
  } = useExisteListaAsistenciaDeHoySpa();

  const onCloseInformationModal = () => {
    navigate(RUTA_ASISTENCIA);
  };

  return (
    <Page
      title="Check-in diario de Spa"
      description="Registro de asistencia de mascotas con baños programados para el día de hoy."
      breadCrumbs={breadCrumbs}
    >
      <Row className="justify-content-center">
        <div className="col-xs-12 col-md-10 col-lg-10 col-xxl-7">
          <>
            {existeListaDeHoy && isSuccess && <TableSection />}
            {!existeListaDeHoy && isSuccess && (
              <InformationModal
                message="No hay asistencias programadas para el día de hoy."
                onClose={onCloseInformationModal}
              />
            )}
            {error && <ServerErrorModal />}
            {isLoading && <LoadingScreen isLoading={isLoading} />}
          </>
        </div>
      </Row>
    </Page>
  );
}

export default CheckinAsistenciaSpa;
